import angular from 'angular'
import './storyboard_event.service'

angular
  .module('admin.storyboard_event', ['admin.storyboard_event.service'])
  .controller('StoryboardEventCtrl', StoryboardEventCtrl)

/** @ngInject */
function StoryboardEventCtrl($scope, StoryboardEventService, ConfigurationsService, UploadService) {
  var vm = this
  vm.items = []

  function load() {
    ConfigurationsService.list().then(function (result) {
      vm.items = _.filter(result.results, function (o) {
        return (
          o.key === 'STORYBOARD_EVENT_NAME' ||
          o.key === 'STORYBOARD_EVENT_TAB_NAME' ||
          o.key === 'STORYBOARD_EVENT_SET_IDS' ||
          o.key === 'STORYBOARD_EVENT_CHANNEL_IDS'
        )
      })
    })
  }

  load()

  vm.add = function () {
    vm.config = {
      id: 0,
      key: '',
      value: '',
    }
    $('#modalConfig').modal('show')
  }

  vm.edit = function (item) {
    vm.config = angular.copy(item)
    try {
      if (isNaN(Number(vm.config.val))) {
        vm.config.val = JSON.stringify(JSON.parse(vm.config.val), null, 2)
        vm.config.isJson = true
      } else {
        vm.config.isJson = false
      }
    } catch (e) {
      vm.config.isJson = false
    }

    $('#modalConfig').modal('show')
  }

  vm.save = function () {
    if (!vm.config.key) {
      swal('You need add a Key', '', 'warning')
      return
    }

    var existItem = _.filter(vm.allItems, function (o) {
      return o.key === vm.config.key && o.id !== 0
    })

    if (existItem.length === 0) {
      ConfigurationsService.set(vm.config.key, { value: vm.config.val }).then(function () {
        load()
        $('#modalConfig').modal('hide')
        vm.config = null
      })
    } else {
      swal(
        {
          title: 'Are you sure?',
          text: 'You will change the value of an existing record.',
          type: 'warning',
          showCancelButton: true,
          closeOnConfirm: true,
          closeOnCancel: true,
          animation: 'slide-from-top',
        },
        function (isConfirm) {
          if (isConfirm) {
            ConfigurationsService.set(vm.config.key, {
              value: vm.config.val,
            }).then(function () {
              load()
              $('#modalConfig').modal('hide')
              vm.config = null
            })
          }
        },
      )
    }
  }

  vm.cancel = function () {
    vm.config = null
    $('#modalConfig').modal('hide')
  }
}
